import React, { useEffect, useState } from 'react';
import config from '../config/config';
import { useSearchStateFilters, useSearchStateFiltersDispatch } from '../hooks/useSearchStateFilters';
import SearchFiltersRange from './generic/SearchFiltersRange';
/*
    Range and input filters for price
*/
const SearchFilterRangePrice = () => {
	const dispatch = useSearchStateFiltersDispatch();
	const { priceRange } = useSearchStateFilters();
	const [ initialValues, setInitialValues ] = useState( null );

	const onChange = ( newMin, newMax ) => {
		const min = newMin <= config.PRICE_RANGE[ 0 ] ? null : newMin;
		const max = newMax >= config.PRICE_RANGE[ 1 ] ? null : newMax;
		dispatch( {
			type: 'changed',
			priceRange: [ min, max ],
		} );
	};
	useEffect( () => {
		setInitialValues( priceRange );
	}, [] );

	if ( ! initialValues ) {
		return null;
	}

	return (
		<SearchFiltersRange
			label={`Price Range`}
			range={config.PRICE_RANGE}
			name={'Price'}
			roundTo={10000}
			onChange={onChange}
			format={'currency'}
			initialValues={initialValues}
			valuesToResetOn={priceRange}
			attributeMax={config.FILTER_ATTRIBUTES.priceMax}
			attributeMin={config.FILTER_ATTRIBUTES.priceMin}
		/>
	);
};

export default SearchFilterRangePrice;

